import { ProductName } from '../components/ProductName';
import { useProductNameService } from '../services/useProductNameService';

export interface ProductNameContainerProps {
  className?: string;
}

export const ProductNameContainer: React.FC<React.PropsWithChildren<ProductNameContainerProps>> = ({ className }) => {
  const { productName } = useProductNameService();

  return <ProductName className={className}>{productName}</ProductName>;
};
